import { useSelector } from "react-redux";
import "./Label.scss";

const Label = ({ label, required }) => {
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};

  return (
    <div id="label-container">
      <label className={`text-16-400 ${isDarkMode ? "color-ffff" : "color-2749"}`} htmlFor={`${label}`}>
        {label}
        {required && "*"}
      </label>
    </div>
  );
};

export default Label;
